import { render, staticRenderFns } from "./InventoryByReference.vue?vue&type=template&id=6ffbcb9a&"
import script from "./InventoryByReference.vue?vue&type=script&lang=js&"
export * from "./InventoryByReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports